export default __webpack_public_path__ + "static/media/understanding_the_indicators_1.c7ea4ea4.png";